import React from "react";
import { useSpring, animated } from "@react-spring/web";
import { useInView } from "react-intersection-observer";

const easeOutExpo = (t) => 1 - Math.pow(2, -10 * t); // Easing function

const Counter = ({ targetNumber = 5000, duration = 2000, className = "" }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.5 });

  const { number } = useSpring({
    from: { number: 0 },
    to: { number: inView ? targetNumber : 0 },
    config: { duration },
    easing: easeOutExpo, // Smooth deceleration
  });

  return (
    <div ref={ref} className={`stat-text-2 text-center ${className}`}>
      <animated.span>{number.to((n) => Math.floor(n))}</animated.span>
      <span> +</span>
    </div>
  );
};

export default Counter;
